import axios from 'axios';
import { getAuth } from 'firebase/auth';

export const uploadFile = async (
  file: Blob | File,
  folder: string = 'general',
  onProgress?: (progress: number) => void
): Promise<string> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();

  if (!token) {
    throw new Error('User not authenticated');
  }

  const formData = new FormData();
  const fileName = (file as File).name || `upload-${Date.now()}`;
  formData.append('file', file, fileName);
  formData.append('folder', folder);

  const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';

  const response = await axios.post<{ url: string }>(`${baseURL}/storage/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total && onProgress) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    },
  });

  return response.data.url;
};
